import { Component, Input, OnInit } from '@angular/core';
import {ViewCell} from '../../ng2-smart-table/components/cell/cell-view-mode/view-cell';

@Component({
  selector: 'app-table-blocklist-format-number',
  template: `<span>+91 {{value}}</span>`,
  styles: []
})
export class TableBlocklistFormatNumberComponent implements ViewCell, OnInit {

  @Input() value: string | number;
  @Input() rowData: any;  
  
  statusClass : string;
  statusText : string;

  ngOnInit() {
    console.log(this.value);
  }
}
